import {
  Checkbox,
  Typography,
  TextField,
  makeStyles,
  FormControlLabel,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { classes as workerStyles } from "../AddWorkerStyles";
import React, { useEffect, useState } from "react";
import { getLocationForCountry } from "services/bulkUpload";
import { Controller, useFormContext } from "react-hook-form";
import { isEmptyObject } from "utils";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";

const useStyles = makeStyles((theme) => workerStyles(theme));

const CrozierUserAccess = ({
  selectedWorker,
  manager,
  initialValue,
  setCrozierValid,
  setIsCrozierWorker,
  setCrozierDistBuilingMap,
}) => {
  const classes = useStyles();
  const { control, setValue, getValues, errors, clearErrors } =
    useFormContext();
  const [districts, setDistricts] = useState([]);
  const [isActiveTicked, setIsActiveTicked] = useState(false);
  const [crozierDistrict, setCrozierDistrict] = useState([]);
  const [crozierBuilding, setCrozierBuilding] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    selectedWorker
      ? getLocationForCountry(
          //selectedWorker.worker?.countryCode,
          //selectedWorker.worker?.alternateCountryCode
        )
          .then((data) => {
            let districtBuildingObj = {};
            data.forEach((record) => {
              let DistCrozierEnabled = false;
              let buildingIdMap = {};
              Object.entries(record.buildings).map((buildingDet) => {
                if (
                  buildingDet[1].crozierEnabled === true &&
                  buildingDet[1].activityEnabled === true
                ) {
                  DistCrozierEnabled = true;
                  buildingIdMap[buildingDet[0]] = {
                    buildingID: buildingDet[0],
                    districtID: record.district,
                  };
                }
              });
              if (buildingIdMap && Object.keys(buildingIdMap).length > 0) {
                districtBuildingObj[record.district] = buildingIdMap;
              }
              record.DistCrozierEnabled = DistCrozierEnabled;
            });
            const filteredDistricts = data.filter((record) => {
              if (record.DistCrozierEnabled === true) {
                return record.district;
              }
            });
            setCrozierDistBuilingMap(districtBuildingObj);
            setDistricts([...filteredDistricts]);
          })
          .catch((err) => {
            console.log("Get districts in Crozier User access ", err);
          })
      : getLocationForCountry(
          //manager?.countryCode,
         // manager?.alternateCountryCode
        )
          .then((data) => {
            let districtBuildingObj = {};
            data.forEach((record) => {
              let DistCrozierEnabled = false;
              let buildingIdMap = {};
              Object.entries(record.buildings).map((buildingDet) => {
                if (
                  buildingDet[1].crozierEnabled === true &&
                  buildingDet[1].activityEnabled === true
                ) {
                  DistCrozierEnabled = true;
                  buildingIdMap[buildingDet[0]] = {
                    buildingID: buildingDet[0],
                    districtID: record.district,
                  };
                }
              });
              if (buildingIdMap && Object.keys(buildingIdMap).length > 0) {
                districtBuildingObj[record.district] = buildingIdMap;
              }

              record.DistCrozierEnabled = DistCrozierEnabled;
            });
            const filteredDistricts = data.filter((record) => {
              if (record.DistCrozierEnabled === true) {
                return record.district;
              }
            });
            setCrozierDistBuilingMap(districtBuildingObj);
            setDistricts([...filteredDistricts]);
          })
          .catch((err) => {
            console.log("Get districts in Crozier ", err);
          });
  }, []);
  useEffect(() => {
    if (!isEmptyObject(initialValue) && districts && districts.length > 0) {
      setValue("isCrozierActive", initialValue.isActive);
      if (initialValue.crozierDistrict && initialValue.crozierDistrict.length > 0) {
        let districtData = [];
        districts.forEach((record) => {
          if (initialValue.crozierDistrict.includes(record.district)) {
            districtData.push(record);
          }
        });
        setValue("crozierDistrict", districtData);
      }
      if (
        initialValue.crozierBuildings &&
        initialValue.crozierBuildings.length > 0
      ) {
        setValue(
          "crozierBuilding",
          initialValue.crozierBuildings.map((item) => item.buildingID)
        );
        if (
          initialValue.crozierDistrict &&
          initialValue.crozierDistrict.length > 0
        ) {
          let activatedBuildings = [];
          getValues("crozierDistrict").forEach((record) => {
            const buildingsData = record.buildings;
            let buildingIds = Object.keys(buildingsData).filter(
              (e) =>
                buildingsData[e].activityEnabled === true &&
                buildingsData[e].crozierEnabled === true
            );
            activatedBuildings.push(...buildingIds);
          });
          setBuildings(activatedBuildings);
        }
      } else if (getValues("crozierDistrict").length > 0) {
        let activatedBuildings = [];
        getValues("crozierDistrict").forEach((record) => {
          const buildingsData = record.buildings;
          let buildingIds = Object.keys(buildingsData).filter(
            (e) =>
              buildingsData[e].activityEnabled === true &&
              buildingsData[e].crozierEnabled === true
          );
          activatedBuildings.push(...buildingIds);
        });
        setBuildings(activatedBuildings);
      } else {
        setValue("crozierBuilding", []);
      }
      setValue("isCrozierActive", initialValue.isActive);
      setIsActiveTicked(initialValue?.isActive);
      setCrozierDistrict(initialValue?.crozierDistrict);
      setCrozierBuilding(initialValue?.crozierBuildings);
    }
  }, [initialValue, districts]);

  useEffect(() => {
    if (getValues("isCrozierActive") || initialValue?.isActive) {
      setIsCrozierWorker(true);
    } else {
      setIsCrozierWorker(false);
    }
  }, [isActiveTicked]);

  useEffect(() => {
    if (getValues("isCrozierActive")) {
      console.log("if cond:", getValues("crozierDistrict"));
      if (
        getValues("crozierDistrict")?.length === 0 ||
        getValues("crozierBuilding")?.length === 0
      ) {
        setCrozierValid(false);
      } else setCrozierValid(true);
    } else {
      setCrozierValid(true);
    }
  }, [
    getValues("isCrozierActive"),
    getValues("crozierDistrict"),
    getValues("crozierBuilding"),
  ]);
  return (
    <>
      <Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
        {t("other.lblCrozierUserAccess")}
      </Typography>

      <FormControlLabel
        control={
          <Controller
            name="isCrozierActive"
            control={control}
            defaultValue={isActiveTicked}
            render={(props) => (
              <>
                <Checkbox
                  {...props}
                  checked={props.value}
                  onChange={(e) => {
                    setIsActiveTicked(e.target.checked);
                    props.onChange(e.target.checked);
                  }}
                  color="primary"
                  style={{ paddingLeft: 0 }}
                  inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblEnableCrozierAccess")}
      />

      <Controller
        name="crozierDistrict"
        control={control}
        defaultValue={crozierDistrict}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={districts}
            value={props.value}
            disableClearable
            disabled={!isActiveTicked}
            getOptionLabel={(option) =>
              option.district ? option.district : option
            }
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="crozierDistrict"
                name="crozierDistrict"
                label={properCase( props.value.length > 0 ? t( "other.lblDistrict") : t( "general.select1" ))}
                required={getValues("isCrozierActive")}
                error={Boolean(errors.crozierDistrict)}
                helperText={
                  errors?.crozierDistrict?.type === "validate"
                    ? "District cannot be blank"
                    : ""
                }
              />
            )}
            onChange={(e, newValue) => {
              props.onChange(newValue);
              if (!newValue || newValue.length <= 0) {
                setValue("crozierBuilding", []);
              }
              console.log("##newvalue", newValue);
              let activatedBuildings = [];
              newValue.forEach((record) => {
                if (record.buildings) {
                  console.log("####crozier", record.buildings);
                  const buildingsData = record.buildings;
                  let buildingIds = Object.keys(buildingsData).filter(
                    (e) =>
                      buildingsData[e].activityEnabled === true &&
                      buildingsData[e].crozierEnabled === true
                  );
                  activatedBuildings.push(...buildingIds);
                }
              });

              if (getValues("crozierBuilding").length > 0) {
                const filteredbuildingIds = getValues("crozierBuilding").filter(
                  (buildingId) => {
                    return activatedBuildings.includes(buildingId);
                  }
                );
                setValue("crozierBuilding", filteredbuildingIds);
              }

              setBuildings(activatedBuildings);
            }}
          />
        )}
      />

      <Controller
        name="crozierBuilding"
        control={control}
        defaultValue={crozierBuilding}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={buildings}
            value={props.value}
            disableClearable
            disableCloseOnSelect
            disabled={!isActiveTicked}
            getOptionLabel={(option) =>
              option?.buildingID ? option.buildingID : option
            }
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="crozierBuilding"
                name="crozierBuilding"
                label={properCase( props.value && props.value.length > 0 ? t( "other.lblBuilding") : t( "general.select2" ))}
                required={getValues("isCrozierActive")}
                error={Boolean(errors.crozierBuilding)}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />
    </>
  );
};

export default CrozierUserAccess;
